const config = {
    build_number: '617020',
    build_timestamp: '2026-10-15T17:34:45.045Z',
    build_commit: 'f03186daa21da2e78470ef36a9bcc15e3688bbb7',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
